var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2143 12.2857V9.92857M16.2143 12.2857C14.91 12.2857 13.8571 12.2857 13.8571 13.8571C13.8571 16.2143 18.5714 16.2143 18.5714 18.5714C18.5714 20.1429 17.5186 20.1429 16.2143 20.1429M16.2143 12.2857C17.5186 12.2857 18.5714 12.8829 18.5714 13.8571M13.8571 18.5714C13.8571 19.75 14.91 20.1429 16.2143 20.1429M16.2143 20.1429V22.5",
    stroke: "#DB1C29",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2143 26.4286C21.8555 26.4286 26.4286 21.8555 26.4286 16.2143C26.4286 10.5731 21.8555 6 16.2143 6C10.5731 6 6 10.5731 6 16.2143C6 21.8555 10.5731 26.4286 16.2143 26.4286Z",
    stroke: "#DB1C29",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/Accounts.05a349a7e876a8002867043228ae0f65.svg";
export { ForwardRef as ReactComponent };